import _extends from "@babel/runtime-corejs3/helpers/extends";
import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'react-final-form';
import { ConsentTypeChoice } from '@unite-us/client-utils';
import { Button, InputField } from '@unite-us/ui';
import { CONSENT_OPTIONS } from '../../constants';
import ConsentFileUpload from './ConsentFileUpload';
import { composeValidators } from '../../../utils/composeValidators';
import { isEmail, isPhoneNumber, isRequired } from '../../../utils/validations';
function ConsentTypeChoices(_ref) {
  var onSubmit = _ref.onSubmit,
    selectConsentType = _ref.selectConsentType,
    selectedConsentType = _ref.selectedConsentType,
    showConsent = _ref.showConsent,
    downloadConsentUrl = _ref.downloadConsentUrl,
    verbalScriptUrl = _ref.verbalScriptUrl,
    fileUpload = _ref.fileUpload,
    onFileUpload = _ref.onFileUpload;
  var changeConsentType = function changeConsentType(type) {
    selectConsentType(type);
    onFileUpload(null);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "consent-type-choices"
  }, /*#__PURE__*/React.createElement("div", {
    className: "consent-type-choices-group attestation-consent"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "consent-type-choices-group__title"
  }, "User Attestation"), /*#__PURE__*/React.createElement(ConsentTypeChoice, {
    type: CONSENT_OPTIONS.ON_SCREEN_ATTESTATION,
    label: "On-Screen Consent by Attestation (Client Consented Verbally)",
    onSelect: changeConsentType,
    selectedType: selectedConsentType
  }, /*#__PURE__*/React.createElement(Button, {
    id: "go-to-form-btn",
    className: "consent-go-to-form-btn",
    label: "Go To Form",
    primary: true,
    onClick: function onClick() {
      return showConsent({
        isConsentAttestation: true
      });
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "consent-type-choices-group"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "consent-type-choices-group__title"
  }, "Digital Consent"), /*#__PURE__*/React.createElement("div", {
    className: "consent-type-choices-group__choices"
  }, /*#__PURE__*/React.createElement(ConsentTypeChoice, {
    type: CONSENT_OPTIONS.PHONE_NUMBER,
    label: "Send request for signature by text message (SMS)",
    onSelect: changeConsentType,
    selectedType: selectedConsentType
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(Field, {
    name: CONSENT_OPTIONS.PHONE_NUMBER,
    validate: composeValidators(isPhoneNumber, isRequired)
  }, function (props) {
    return /*#__PURE__*/React.createElement(InputField, _extends({
      id: "phone-number",
      label: "Phone Number",
      hideLabel: true,
      disabled: selectedConsentType !== CONSENT_OPTIONS.PHONE_NUMBER,
      mask: "(999) 999-9999"
    }, props));
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/React.createElement(Button, {
    id: "consent-submit-phone-btn",
    className: "consent-submit-request-by-phone-btn",
    label: "Submit",
    onClick: onSubmit,
    primary: true
  })))), /*#__PURE__*/React.createElement(ConsentTypeChoice, {
    type: CONSENT_OPTIONS.EMAIL_ADDRESS,
    label: "Send request for signature by Email",
    onSelect: changeConsentType,
    selectedType: selectedConsentType
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(Field, {
    name: CONSENT_OPTIONS.EMAIL_ADDRESS,
    validate: composeValidators(isEmail, isRequired)
  }, function (props) {
    return /*#__PURE__*/React.createElement(InputField, _extends({
      id: "email-address",
      label: "Email Address",
      hideLabel: true,
      disabled: selectedConsentType !== CONSENT_OPTIONS.EMAIL_ADDRESS
    }, props));
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/React.createElement(Button, {
    id: "consent-submit-email-btn",
    className: "consent-submit-request-by-email-btn",
    label: "Submit",
    onClick: onSubmit,
    primary: true
  })))), /*#__PURE__*/React.createElement(ConsentTypeChoice, {
    type: CONSENT_OPTIONS.ON_SCREEN,
    label: "On-Screen Consent",
    onSelect: changeConsentType,
    selectedType: selectedConsentType
  }, /*#__PURE__*/React.createElement(Button, {
    id: "go-to-form-btn",
    className: "consent-go-to-form-btn",
    label: "Go To Form",
    primary: true,
    onClick: function onClick() {
      return showConsent({
        isConsentAttestation: false
      });
    }
  })))), (downloadConsentUrl || verbalScriptUrl) && /*#__PURE__*/React.createElement("div", {
    className: "consent-type-choices-group paper-and-verbal-consent"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "consent-type-choices-group__title"
  }, "Paper And Verbal Consent"), /*#__PURE__*/React.createElement("div", {
    className: "consent-type-choices-group__choices"
  }, downloadConsentUrl && /*#__PURE__*/React.createElement(ConsentTypeChoice, {
    type: CONSENT_OPTIONS.DOCUMENT,
    label: "Upload signed paper form",
    onSelect: changeConsentType,
    selectedType: selectedConsentType,
    dropzone: /*#__PURE__*/React.createElement(ConsentFileUpload, {
      file: fileUpload,
      onFileChanged: onFileUpload,
      type: CONSENT_OPTIONS.DOCUMENT
    })
  }, /*#__PURE__*/React.createElement("a", {
    id: "download-consent-form-link",
    style: {
      color: 'grey',
      textDecoration: 'underline',
      fontSize: '14px'
    },
    target: "_blank",
    href: downloadConsentUrl,
    rel: "noreferrer noopener",
    download: true
  }, "Download Consent Form")), verbalScriptUrl && /*#__PURE__*/React.createElement(ConsentTypeChoice, {
    type: CONSENT_OPTIONS.AUDIO,
    label: "Upload audio file (client consented verbally)",
    onSelect: changeConsentType,
    selectedType: selectedConsentType,
    dropzone: /*#__PURE__*/React.createElement(ConsentFileUpload, {
      file: fileUpload,
      onFileChanged: onFileUpload,
      type: CONSENT_OPTIONS.AUDIO
    })
  }, /*#__PURE__*/React.createElement("a", {
    id: "view-verbal-consent-link",
    style: {
      color: 'grey',
      textDecoration: 'underline',
      fontSize: '14px'
    },
    href: verbalScriptUrl,
    target: "_blank"
  }, "View Verbal Consent Script")))));
}
ConsentTypeChoices.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  selectConsentType: PropTypes.func.isRequired,
  selectedConsentType: PropTypes.string.isRequired,
  showConsent: PropTypes.func.isRequired,
  downloadConsentUrl: PropTypes.string,
  verbalScriptUrl: PropTypes.string,
  fileUpload: PropTypes.object,
  onFileUpload: PropTypes.func.isRequired
};
ConsentTypeChoices.defaultProps = {
  fileUpload: null
};
export default ConsentTypeChoices;
//# sourceMappingURL=ConsentTypeChoices.js.map